module.exports = __webpack_public_path__ + "img/manual.ca2fe247.png";